// 京东 PC / 移动端 / 国际站三种域名对应同一个商品，取值与 mdm-boot 的 JdProductLink 一致。
// 短链 u.jd.com 不认：展开要发网络请求。
const JD_PRODUCT_LINK_PATTERN =
  /^(?:https?:\/\/)?(?:item\.jd\.com|item\.m\.jd\.com|npcitem\.jd\.hk)\/(?:product\/)?(\d+)\.html(?:[?#].*)?$/i

/** 京东商品链接截断为 `https://item.jd.com/{skuId}.html`，其余链接原样返回。 */
export const normalizeJdProductLink = (link: string) => {
  const matched = JD_PRODUCT_LINK_PATTERN.exec(link.trim())
  return matched ? `https://item.jd.com/${matched[1]}.html` : link
}
// 京东 PC / 移动端 / 国际站三种域名对应同一个商品，取值与 mdm-boot 的 JdProductLink 一致。
// 短链 u.jd.com 不认：展开要发网络请求。
const JD_PRODUCT_LINK_PATTERN =
  /^(?:https?:\/\/)?(?:item\.jd\.com|item\.m\.jd\.com|npcitem\.jd\.hk)\/(?:product\/)?(\d+)\.html(?:[?#].*)?$/i

/** 京东商品链接截断为 `https://item.jd.com/{skuId}.html`，其余链接原样返回。 */
export const normalizeJdProductLink = (link: string) => {
  const matched = JD_PRODUCT_LINK_PATTERN.exec(link.trim())
  return matched ? `https://item.jd.com/${matched[1]}.html` : link
}
